export const getFormattedDate = (isoDate) => {
  const date = new Date(isoDate);
  const formatted = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  return formatted;
};
